/**
 * @desc 根据时间范围获取ebs汇率集合
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.EbsRateResponse>>;
export function request(body: defs.basics.EbsRateRequest, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/basics/getEbsRate`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
